export default props => ({
    // Default Theme...
    fontFamily: props.theme.font.heading,
    underlineColor: props.theme.brand01,

    // Override with custom theme
    ...props.theme?.core?.heading
  });
